<div
  class="mbs-number"
  [ngClass]="[size ? '-' + size : '']">
  @if (label && id) {
    <mbs-input-label
      [boldLabel]="boldLabel"
      [disabled]="disabledState"
      [id]="id"
      [info]="info"
      [infoPlacement]="infoPlacement"
      [infoTriggers]="infoTriggers"
      [infoContainer]="infoContainer"
      [label]="label"
      [labelClasses]="labelClasses"
      [labelContentClasses]="labelContentClasses"
      [labelSize]="labelSize"
      [required]="hasRequiredValidator && showRequiredMark" />
  }
  <div [class]="calculatedContainerClasses">
    <input
      class="form-control mbs-number-input"
      [attr.aria-describedby]="id"
      [attr.aria-labelledby]="label"
      [autocomplete]="'off'"
      [disabled]="disabledState"
      [id]="id"
      [imask]="imaskOpts"
      [ngClass]="bindClasses"
      [placeholder]="placeholder"
      [tabindex]="tabindex"
      [unmask]="true"
      (accept)="handleAccept($event)"
      (blur)="numberHandleBlur($any($event))"
      (change)="numberChangeHandler($event)"
      (focus)="handleFocus($event)"
      (input)="handleInput($any($event))"
      (keydown.ArrowDown)="$event.preventDefault(); changeValueHandler(false)"
      (keydown.ArrowUp)="$event.preventDefault(); changeValueHandler()" />

    @if (showButtons) {
      <mbs-input-pre-append
        class="mbs-number-buttons"
        [disabled]="disabledState"
        [position]="'append'">
        <ng-template>
          <mbs-group-button [vertical]="true">
            <mbs-button
              class="mbs-number-btn -up"
              [attr.data-e2e]="elementSelectors.id.btnUp"
              [disabled]="disabledState || value >= max"
              [icon]="'ico ico-PlusThin mr-0'"
              [size]="size"
              (click)="changeValueHandler()" />

            <mbs-button
              class="mbs-number-btn -down"
              [attr.data-e2e]="elementSelectors.id.btnDown"
              [disabled]="disabledState || value <= min"
              [icon]="'ico ico-MinusThin mr-0'"
              [size]="size"
              (click)="changeValueHandler(false)" />
          </mbs-group-button>
        </ng-template>
      </mbs-input-pre-append>
    }
  </div>

  @if (isErrorsShow) {
    <mbs-input-errors
      [errors]="errors"
      [errorsTemplate]="errorsTemplate?.templateRef" />
  }
</div>
